module.exports = __webpack_public_path__ + "img/chat_bg.dcce1cca.jpg";